import React from 'react';
import apiService from '../../services/api';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

import './SurveyPopup.css';
import ViewSurveyTemplate from '../../services/viewSurveytemplate';

const close= apiService.getBlobAssetUrl('close_popup.svg');

const SurveyDetailsPopup = ({ surveyId, onClose }) => {
  return (
    <div className="survey-details-popup-overlay">
      <div className="survey-details-popup">
        <div className="survey-details-popup-header">
          <h2>Survey Details</h2>
          <Button onClick={onClose}>
            <img src={close} alt="close" className="close-img" />
          </Button>
        </div>
        <ViewSurveyTemplate surveyId={surveyId} />
        {/* <div className="survey-details-modal-footer">
              
              <button type="button"  id="popup-cancel" onClick={onClose}>
                Cancel
              </button>
            </div> */}
      </div>
    </div>
  );
};

SurveyDetailsPopup.propTypes = {
  surveyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onClose: PropTypes.func.isRequired,
};
export default SurveyDetailsPopup;